import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { concatMap, map, catchError, of, withLatestFrom } from "rxjs";
import { CurrencyClient } from "src/api-service";
import { selectSelectedCompany } from "../../../../user/user.selectors";
import { CurrenciesActions } from "./currencies.actions";
import { DataCurrenciesActions } from "../../../../application/data/currency/currencies/currencies.actions";
import { normalizeError } from "../../../../app-store-error.types";

@Injectable()
export class CurrenciesEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly currencyClient = inject(CurrencyClient);

    updateCurrency$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrenciesActions.updateCurrency),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            concatMap(([{ request, id }, selectedCompany]) =>
                this.currencyClient.patchCurrency(selectedCompany.id, id, request).pipe(
                    map(() =>
                        CurrenciesActions.updateCurrencySuccess({
                            response: [],
                            toastKey: "ADMIN_PANEL.EDIT_CURRENCY_SECTIONS.TOAST.UPDATE_SUCCESS",
                        }),
                    ),
                    catchError(error =>
                        of(
                            CurrenciesActions.updateCurrencyFailure({
                                error: normalizeError(error),
                                toastKey: "ADMIN_PANEL.EDIT_CURRENCY_SECTIONS.TOAST.UPDATE_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    // Reload global currencies store after successful update
    reloadCurrenciesAfterUpdate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrenciesActions.updateCurrencySuccess),
            withLatestFrom(this.store.select(selectSelectedCompany)),
            map(([, selectedCompany]) => DataCurrenciesActions.load({ companyId: selectedCompany.id })),
        ),
    );
}
